import Vue from 'vue'

// Enumerate global components
const globalComponents = require.context('./global', false, /\w+.vue/)

globalComponents.keys().forEach((filename) => {

	const component = globalComponents(filename)
	const componentName = filename.split('/').pop().replace(/\.\w+$/, '')

	Vue.component(componentName, component.default || component)
})